export interface ISnapData {
  snapData: SnapDataType | {};
  fetchSnapDataStatus: FetchStatusType | FetchStatusType.NOT_STARTED;
  hasData: boolean | null;
  hasReviewData: boolean | null;
  pendingReviewData: boolean;
  reviewData: ReviewDataList | {};
  reviewDetailType:
    | ReviewDetailType
    | {offset: 0; limit: 5; tagIds: []; filter: ''; sortBy: ''; searchText: ''; reviewId: ''};
  qnaDetailType:
    | QnaDetailType
    | {
        offset: 0;
        limit: 5;
        filter: [];
        sortBy: '';
      };
  paginatorStatus: Array<string>;
  qnaFilterData: Array<FilterData>;
  hasQnaData: boolean | null;
  pendingQnaData: boolean;
  qnaData: QNADataType;
  qnaPaginatorStatus: Array<string>;
  selTagIds: Array<string>;
  selRnrTagIds: Array<string>;
  newQuestions: Array<string>;
  loadingUserReviews: boolean;
  moreUgcImages: Array<any>;
  hasMoreImages: boolean | null;
  selectedRnRType: string | '';
  selectedGalleryTab: string | '';
  rnrImages: Array<any> | [];
  isUgcChipSelected: boolean;
}

export const SET_SNAP_DATA = 'SET_SNAP_DATA';
export const UPDATE_HASDATA = 'UPDATE_HASDATA';
export const SET_USER_REVIEWS = 'SET_USER_REVIEWS';
export const UPDATE_HASREVIEWDATA = 'UPDATE_HASREVIEWDATA';
export const UPDATE_HAS_QNADATA = 'UPDATE_HAS_QNADATA';
export const UPDATE_REVIEW_DETAILS = 'UPDATE_REVIEW_DETAILS';
export const UPDATE_PAGINATOR_STATUS = 'UPDATE_PAGINATOR_STATUS';
export const SET_QNA_FILTER = 'SET_QNA_FILTER';
export const SET_QNA_DATA = 'SET_QNA_DATA';
export const UPDATE_QNA_DETAILS = 'UPDATE_QNA_DETAILS';
export const UPDATE_QNAPAGINATOR_STATUS = 'UPDATE_QNAPAGINATOR_STATUS';
export const UPDATE_QNA_TAGS = 'UPDATE_QNA_TAGS';
export const UPDATE_NEW_QUESTIONS = 'UPDATE_NEW_QUESTIONS';
export const SET_REVIEW_DATA_STATUS = 'SET_REVIEW_DATA_STATUS';
export const SET_QNA_DATA_STATUS = 'SET_QNA_DATA_STATUS';
export const SET_MORE_IMAGES = 'SET_MORE_IMAGES';
export const UPDATE_HAS_MOREIMAGES = 'UPDATE_HAS_MOREIMAGES';
export const SELECTED_RNR_TYPE = 'SELECTED_RNR_TYPE';
export const UPDATE_RNR_TAGS = 'UPDATE_RNR_TAGS';
export const SET_IMAGE_LOADING_STATE = 'SET_IMAGE_LOADING_STATE';
export const SET_SELECTED_GALLERY_TAB = 'SET_SELECTED_GALLERY_TAB';
export const SET_USER_REVIEWS_LOADING_STATE = 'SET_USER_REVIEWS_LOADING_STATE';
export const TOGGLE_UGC_CHIP_SELECTED = 'TOGGLE_UGC_CHIP_SELECTED';
export const SET_RNR_IMAGES = 'SET_RNR_IMAGES';
export const UPDATE_SNAPSHOT_DATA_FETCH_STATUS = 'UPDATE_SNAPSHOT_DATA_FETCH_STATUS';

export enum FetchStatusType {
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED',
}

export interface ISET_SNAP_DATA {
  type: typeof SET_SNAP_DATA;
  actionData: SnapDataType;
}

export interface IUPDATE_HAS_MOREIMAGES {
  type: typeof UPDATE_HAS_MOREIMAGES;
  actionData: boolean;
}

export interface ISELECTED_RNR_TYPE {
  type: typeof SELECTED_RNR_TYPE;
  actionData: string;
}

export interface UserReviewType {
  voyagerId: string;
  hotelName: string;
  hotelCity: string;
  reviewTitle: string;
  reviewContent: string;
  totalRating: number;
  hotelReply: {
    createdAt: string;
    designation: string;
    response: string;
    repliedAfter: string;
    moderatedBy: string;
    moderatedAt: string;
  };

  monthOfStay: number;
  submittedAt: string;
  fromBooking: boolean;
  deviceType: string;
  imageCount: number;
  approvedImageCount: number;
  likeCount: number;
  id: string;
  reviewerId: string;
  firstName: string;
  lastName: string;
  image_url?: string;
  featured: boolean;
  roomInfo: {
    id: string;
    name: string;
  };
  tagIds: null;
  tagKeyMapping: null;
  reviewerInfo: {
    hrc: number;
    frc: number;
    brc: number;
    ac: number;
    qc: number;
    badgeName: string;
    badgeIconUrl: string;
  };
  images?: [
    {
      id: string;
      url: string;
      bigUrl: string;
      thumbUrl: string;
      mobileThumbUrl: string;
      hotelReviewId: string;
    },
  ];
  askQuestion: number;
  travellerData: {
    text: string;
  };
}

export interface ReviewDataList {
  reviews: UserReviewType[];
  tagData: [
    {
      id: string;
      name: string;
      count: number;
      sentiment: string;
      root: string;
      rootSlug: string;
      tags: [string];
    },
  ];
  reviewsCount: number;
  filterData: [];
}

export interface SnapDataType {
  giDataExists: boolean;
  taDataExists: boolean;
  giData: GIDataType;
  taData?: TADataType;
  ugcSrc?: string;
}

export interface TADataType {
  hotelRating: number;
  reviewCount: number;
  ratingImageUrl: string;
  rwc: Array<RatingCountType>;
  ratings: Array<TARatingType>;
  reviews: Array<TAReviewsType>;
}

export interface RatingCountType {
  name: string;
  rating: number;
  count: number;
}

export interface TARatingType {
  imgUrl: string;
  name: string;
  rating: number;
}

export interface TAReviewsType {
  firstName: string;
  ratingImageUrl: string;
  reviewContent: string;
  totalRating: number;
  tripType: string;
}

export interface ReviewType {
  reviewContent: string;
  totalRating: number;
  id: string;
  reviewerId: string;
  firstName: string;
  lastName: string;
  image_url: string;
  reviewCount: number;
  badgeName: string;
  badgeIconUrl: string;
}

export interface ReviewType {
  reviewContent: string;
  totalRating: number;
  id: string;
  reviewerId: string;
  firstName: string;
  lastName: string;
  image_url: string;
  reviewCount: number;
  badgeName: string;
  badgeIconUrl: string;
}

export interface GIDataType {
  reviewCount: number;
  hotelRating: number;
  questionCount: number;
  answerCount: number;
  approvedImageCount: number;
  recommendationPercent: number;
  ratingsOnlyCount: number;
  tags: [
    {
      id: string;
      name: string;
      count: number;
      sentiment: string;
      root: string;
      rootSlug: string;
      tags: [string, string];
    },
  ];
  ratings: [
    {
      id: string;
      name: string;
      rating: number;
    },
  ];
  reviews: ReviewType[];
  rwc: [
    {
      name: string;
      rating: number;
      count: number;
    },
  ];
  persuasion: {
    content: string;
    title: string;
    iconURL: string;
    colorCodeUp: string;
    colorCodeBottom: string;
  };
  recentWindowRating: number;
  recentReviewCount: number;
  contextData: {
    iconUrl: string;
    backgroundImgUrl: string;
    text: string;
    rating: number;
  };
  rText: string;
  csCategoryData: ScorecardDataTypes[];
  csCategoryText: string;
  questions?: [
    {
      question: {
        question: string;
        answerCount: number;
        image_url: string;
        id: string;
        firstName: string;
        lastName: string;
      };
      topAnswers?: [
        {
          answer: string;
          questionId: string;
          image_url: string;
          id: string;
          firstName: string;
          lastName: string;
          relevanceScore: number;
        },
      ];
    },
  ];
}

export interface ScorecardDataTypes {
  name: string;
  id: string;
  per: number;
  iconUrl: string;
  colorCode: string;
  categoryData: CategoryDataTypes;
}

export interface CategoryDataTypes {
  categoryText: string;
  text: string;
  showPerText: boolean;
  type?: string;
  subCategories?: [
    {
      name: string;
      per: number;
      colorCode: string;
      perText?: string;
    },
  ];
}

export interface SnapDataType {
  giData: GIDataType;
  giDataExists: boolean;
}

interface FilterData {
  id: string;
  name: string;
  count: number;
}

interface ReviewDataType {
  reviews: [];
  tagData: [];
}

interface ReviewDetailType {
  offset: number;
  limit: number;
  tagIds: Array<number>;
  filter: string;
  sortBy: string;
  page?: number;
  searchText?: string;
  reviewId?: string;
}

interface QnaDetailType {
  offset: number;
  limit: number;
  filter: Array<string>;
  sortBy: string;
}

export interface QNAData {
  contextType: string;
  submittedAt: string;
  question: string;
  answerCount: number;
  tags: [string];
  image_url: string;
  id: string;
  reviewerId: string;
  firstName: string;
  lastName: string;
  cityVoyId: string;
  askedBy: [
    {
      firstName: string;
      lastName: string;
      image_url: string;
      submittedAt: string;
      id: string;
    },
  ];
  tagIds: [string];
  mostRelevantAnswer: {
    id: string;
    relevanceScore: number;
  };
  latestAnswer: {
    id: string;
    submittedAt: string;
  };
  relevanceScore: number;
  isReportAbused: boolean;
  isReasked: boolean;
  isAnswered: boolean;
  tagsIdMapping: [
    {
      id: string;
      name: string;
    },
  ];
  topAnswer: PostAnswerType;
  reviewerInfo: {
    level: string;
    qc: number;
    ac: number;
    hrc: number;
    brc: number;
    frc: number;
    topBadgeIds: {
      trc?: number;
      tqa?: number;
      tac?: number;
    };
  };
}

export interface PostAnswerType {
  answer: string;
  likeCount: number;
  status: string;
  updatedAt: string;
  submittedAt: string;
  questionId: string;
  image_url: string;
  id: string;
  reviewerId: string;
  deviceType: string;
  t: string;
  voyagerId: string;
  hotelName: string;
  localityId: string;
  localityName: string;
  hotelCity: string;
  cityVoyId: string;
  contextType: string;
  contextId: string;
  firstName: string;
  lastName: string;
  moderatedBy: string;
  moderatedAt: string;
  moderatorsLog: [
    {
      moderatedBy: string;
      moderatedAt: string;
      type: string;
    },
  ];
  relevanceScore: number;
  bscore: {
    iScore: number;
    cScore: number;
    lScore: number;
  };
  score: number;
  isReportAbused: boolean;
  isLiked: boolean;
  isAnswered: boolean;
  reviewerInfo: {
    level: string;
    qc: number;
    ac: number;
    hrc: number;
    brc: number;
    frc: number;
    topBadgeIds: {
      trc: number;
      tac: number;
    };
  };
}

export interface QuesDetailType {
  contextId: string;
  contextType: string;
  voyagerId: string;
  status: string;
  updatedAt: string;
  submittedAt: string;
  createdAt: string;
  question: string;
  answerCount: number;
  tags: [string];
  image_url: null;
  reaskCount: number;
  id: string;
  reviewerId: string;
  deviceType: string;
  firstName: string;
  lastName: string;
  hotelName: string;
  hotelCity: string;
  cityVoyId: string;
  localityId: string;
  localityName: string;
  img_selected: {
    th: {
      vendor: string;
      i: string;
      h: number;
      tag_ids: [number];
      l: string;
      o: number;
      wpl: string;
      ugc_ipt: number;
      u: string;
      t: string;
      w: number;
      at: string;
    };
  };
  askedBy: [
    {
      firstName: string;
      lastName: string;
      image_url: null;
      submittedAt: string;
      id: string;
    },
  ];
  cCode: string;
  country: string;
  autoTagAt: string;
  auto_tagIds: [string];
  auto_tags: [string];
  moderatorsLog: [
    {
      moderatedBy: string;
      moderatedAt: string;
      type: string;
    },
  ];
  notifyReviewers: boolean;
  notRelevantToCommunity: boolean;
  originalquestion: string;
  isEdited: boolean;
  tagIds: [string];
  tagsMatched: boolean;
  latestAnswer: {
    id: string;
    submittedAt: string;
  };
  latestAnsweredAt: string;
  mostRelevantAnswer: {
    id: string;
    relevanceScore: number;
  };
  relevanceScore: number;
  rc: {
    ab: number;
    bb: number;
    hb: number;
    rb: number;
    tc: number;
  };
  score: number;
  answers: [
    {
      answer: string;
      likeCount: number;
      status: string;
      updatedAt: string;
      submittedAt: string;
      questionId: string;
      image_url: string;
      id: string;
      reviewerId: string;
      deviceType: string;
      t: string;
      voyagerId: string;
      hotelName: string;
      localityId: string;
      localityName: string;
      hotelCity: string;
      cityVoyId: string;
      contextType: string;
      contextId: string;
      firstName: string;
      lastName: string;
      moderatorsLog: [
        {
          moderatedBy: string;
          moderatedAt: string;
          type: string;
        },
      ];
      relevanceScore: number;
      bscore: {
        iScore: number;
        cScore: number;
        lScore: number;
      };
      score: number;
      isReportAbused: boolean;
      reviewerInfo: {
        level: string;
        qc: number;
        ac: number;
        hrc: number;
        brc: number;
        frc: number;
        topBadgeIds: {
          trc: number;
          tac: number;
          tqa: number;
        };
      };
    },
  ];
  isAnswered: boolean;
  askedToAnswered: boolean;
  isReasked: boolean;
  isHotelierAnswerPresent: boolean;
  isReportAbused: boolean;
  tagsIdMapping: [
    {
      id: string;
      name: string;
    },
  ];
  reviewerInfo: {
    level: string;
    qc: number;
    ac: number;
    hrc: number;
    brc: number;
    frc: number;
    topBadgeIds: {
      tqa?: number;
      tac?: number;
    };
  };
}

export interface QNADataType {
  success: boolean;
  data: Array<QNAData>;
  count: number;
}

export interface IUPDATE_HASDATA {
  type: typeof UPDATE_HASDATA;
  actionData: boolean;
}

export interface IUPDATE_PAGINATOR_STATUS {
  type: typeof UPDATE_PAGINATOR_STATUS;
  actionData: Array<string>;
}

export interface IUPDATE_QNAPAGINATOR_STATUS {
  type: typeof UPDATE_QNAPAGINATOR_STATUS;
  actionData: Array<string>;
}

export interface IUPDATE_HASREVIEWDATA {
  type: typeof UPDATE_HASREVIEWDATA;
  actionData: boolean;
}

export interface IUPDATE_HAS_QNADATA {
  type: typeof UPDATE_HAS_QNADATA;
  actionData: boolean;
}

export interface ISET_USER_REVIEWS {
  type: typeof SET_USER_REVIEWS;
  actionData: ReviewDataType;
}

export interface IUPDATE_REVIEW_DETAIL {
  type: typeof UPDATE_REVIEW_DETAILS;
  actionData: ReviewDetailType;
}

export interface IUPDATE_QNA_DETAIL {
  type: typeof UPDATE_QNA_DETAILS;
  actionData: QnaDetailType;
}

export interface ISET_QNA_FILTER {
  type: typeof SET_QNA_FILTER;
  actionData: Array<object>;
}

export interface ISET_QNA_DATA {
  type: typeof SET_QNA_DATA;
  actionData: QNADataType;
}

export interface IUPDATEQNATAG {
  type: typeof UPDATE_QNA_TAGS;
  actionData: Array<string>;
}

export interface IUPDATERNRTAG {
  type: typeof UPDATE_RNR_TAGS;
  actionData: Array<string>;
}

export interface IUPDATE_NEW_QUESTIONS {
  type: typeof UPDATE_NEW_QUESTIONS;
  actionData: Array<string>;
}

export interface ISET_REVIEW_DATA_STATUS {
  type: typeof SET_REVIEW_DATA_STATUS;
  actionData: boolean;
}

export interface ISET_QNA_DATA_STATUS {
  type: typeof SET_QNA_DATA_STATUS;
  actionData: boolean;
}

export interface ISET_MORE_IMAGES {
  type: typeof SET_MORE_IMAGES;
  actionData: Array<object>;
}

export interface ISET_IMAGE_LOADING_STATE {
  type: typeof SET_IMAGE_LOADING_STATE;
  actionData: boolean;
}

export interface IIMAGE_GALLERY_TAB {
  type: typeof SET_SELECTED_GALLERY_TAB;
  actionData: string;
}

export interface IUSER_REVIEWS_LOADING_STATE {
  type: typeof SET_USER_REVIEWS_LOADING_STATE;
  actionData: boolean;
}

export interface ITOGGLE_UGC_CHIP_SELECTED {
  type: typeof TOGGLE_UGC_CHIP_SELECTED;
  actionData: boolean;
}

export interface ISET_RNR_IMAGES {
  type: typeof SET_RNR_IMAGES;
  actionData: Array<any>;
}

export interface IUPDATE_SNAPSHOT_DATA_FETCH_STATUS {
  type: typeof UPDATE_SNAPSHOT_DATA_FETCH_STATUS;
  actionData: FetchStatusType;
}

export type UGCDataActionTypes =
  | ISET_SNAP_DATA
  | IUPDATE_HASDATA
  | IUPDATE_HASREVIEWDATA
  | ISET_USER_REVIEWS
  | IUPDATE_REVIEW_DETAIL
  | IUPDATE_PAGINATOR_STATUS
  | ISET_QNA_FILTER
  | ISET_QNA_DATA
  | IUPDATE_QNA_DETAIL
  | IUPDATE_QNAPAGINATOR_STATUS
  | IUPDATEQNATAG
  | IUPDATE_NEW_QUESTIONS
  | ISET_REVIEW_DATA_STATUS
  | ISET_QNA_DATA_STATUS
  | IUPDATE_HAS_QNADATA
  | ISET_MORE_IMAGES
  | IUPDATE_HAS_MOREIMAGES
  | ISELECTED_RNR_TYPE
  | IUPDATERNRTAG
  | ISET_IMAGE_LOADING_STATE
  | IIMAGE_GALLERY_TAB
  | IUSER_REVIEWS_LOADING_STATE
  | ITOGGLE_UGC_CHIP_SELECTED
  | ISET_RNR_IMAGES
  | IUPDATE_SNAPSHOT_DATA_FETCH_STATUS;
